import { render, staticRenderFns } from "./AdminGroupedReportList.vue?vue&type=template&id=2d25f3cc&"
import script from "./AdminGroupedReportList.vue?vue&type=script&lang=js&"
export * from "./AdminGroupedReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports